/*
 ** Runtime APIs we use that are newer than the browser baseline in `nuxt.config.ts`
 ** (`vite.build.target`). Keep the two in sync.
 **
 ** These must stay static side-effect imports, so they are installed no matter the plugin order.
 */
import 'core-js/modules/web.structured-clone.js'
import 'core-js/modules/web.url.parse.js'
import 'core-js/modules/es.array.to-sorted.js'
import 'core-js/modules/es.set.is-disjoint-from.v2.js'
import 'core-js/modules/es.set.difference.v2.js'

export default defineNuxtPlugin({ name: 'polyfills', setup() {} })
